export async function requestLocationPermission(): Promise<PermissionState> {
	if (!("geolocation" in navigator)) {
		return "denied";
	}

	if ("permissions" in navigator) {
		const status = await navigator.permissions.query({ name: "geolocation" });
		if (status.state !== "prompt") {
			return status.state;
		}
	}

	return new Promise((resolve) => {
		navigator.geolocation.getCurrentPosition(
			() => resolve("granted"),
			(error) => {
				if (error.code === error.PERMISSION_DENIED) {
					resolve("denied");
				} else {
					resolve("granted");
				}
			},
			{ timeout: 10000 }
		);
	});
}

export async function requestNotificationPermission(): Promise<NotificationPermission> {
	if (!("Notification" in window)) {
		return "denied";
	}

	if (Notification.permission !== "default") {
		return Notification.permission;
	}

	return Notification.requestPermission();
}

export async function requestAllPermissions(): Promise<{
	location: PermissionState;
	notifications: NotificationPermission;
}> {
	const [location, notifications] = await Promise.all([requestLocationPermission(), requestNotificationPermission()]);

	return { location, notifications };
}
